import PropTypes from 'prop-types';
import SportsFilter from './sports-filter.js';
import MojitoCore from 'mojito/core';

const { UIView } = MojitoCore.Presentation;

/**
 * Menu row letting the user pick a sport, starting with an item that keeps every sport.
 * Renders nothing without sports. The selection is not held by the component itself,
 * see {@link Mojito.Modules.SportsFilterContainer.module|SportsFilterContainer} for a filter wired to its content.
 *
 * @class SportsFilter
 * @memberof Mojito.Presentation.Components
 */

/**
 * SportsFilter prop types.
 *
 * @property {Array<string>} [sportIds] - Sports that can be selected.
 * @property {string} [selectedSportId] - Selected sport. All sports are selected when empty.
 * @property {Function} onSportChange - Callback fired with the selected sport id, or undefined when all sports are selected.
 * @property {string} [class] - Class name assigned to the root element.
 *
 * @memberof Mojito.Presentation.Components.SportsFilter
 */
const propTypes = {
    sportIds: PropTypes.arrayOf(PropTypes.string),
    selectedSportId: PropTypes.string,
    onSportChange: PropTypes.func.isRequired,
    class: PropTypes.string,
};

export default UIView('SportsFilter', SportsFilter, propTypes);
